import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import 'react-dropdown-tree-select/dist/styles.css'
import { SERVER_IP, PORT, PORT_webRTC, ud, logout } from '../../Server'
import swal from 'sweetalert';
import axios from 'axios';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { colourOptions } from './data/data';

var classObj;
class CallIncomming extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            btnDisable: false
        }
    }
    componentDidMount() {
        // alert("CallIncomming")
        // if (sessionStorage.getItem('call_room') == null) {
        //     window.location.href = "/dashboard"
        //     return
        // } else {
        // let caller_info = JSON.parse(sessionStorage.getItem('call_room'))
        // this.setState({ to_caller_list: caller_info.callers, call_type: caller_info.call_type })
        classObj = this.props.incomming_data ? this.props.incomming_data.callerList ? this.props.incomming_data.callerList.length > 1 ? "caller_grid" : "caller_grid columns_caller_grid" : "caller_grid" : "caller_grid"

        return
        // }
    }

    onChangeInput = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }
    callDecline = () => {
        this.props.callDecline("SELF")
        this.setState({ btnDisable: true })
    }
    callAccept = () => {
        this.props.callDecline("SELF")
        this.setState({ btnDisable: true })
    }
    callAccept = () => {
        this.props.callAccept()
        this.setState({ btnDisable: true })
    }
    render() {

        return (
            <div>

                <div className="call_recevier-container" >
                    <div className="call_recevier-wrapper" >
                        <div className="call_info">
                            <div class={classObj} style={{ gridTemplateRows: `repeat(${this.props.incomming_data ? this.props.incomming_data.callerList ? this.props.incomming_data.callerList.length - 1 : 1 : 1}, fr)` }}>
                                {/* Add class - columns_caller_grid - into caller_grid to access multiple grid*/}
                                {this.props.incomming_data ? this.props.incomming_data.callerList ? this.props.incomming_data.callerList.map(list => list.id != ud.id ?
                                    <div class="caller_grid_item" >
                                        <div className="c_g_item">
                                            <div className="caller_pic">
                                                <img src="https://picsum.photos/200/300" alt="caller-pic" />
                                            </div>
                                            <div className="info">
                                                <h2 className="text-dark mt-3">{list.name}</h2>
                                                <p className="text-dark">{list.email}</p>
                                            </div>
                                        </div>

                                    </div> : null
                                ) : null : null}
                            </div>

                            <div className="caller_info text-center pt-3 pb-3 p-2">
                                <div className="c_i_b">
                                    <p className="text-white m-0">Calling you</p>
                                    <div class="spinner">
                                        <div class="bounce1"></div>
                                        <div class="bounce2"></div>
                                        <div class="bounce3"></div>
                                    </div>
                                </div>
                                <div className="call_opt">
                                    <button className="btn btn-danger" disabled={this.state.btnDisable} onClick={this.callDecline}><i className="mdi mdi-phone-hangup"></i></button>
                                    <button className="btn btn-success ml-3" disabled={this.state.btnDisable} onClick={this.callAccept}><i className="mdi mdi-phone"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
}

export default CallIncomming;
